var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.524,
    height: 43.524,
    viewBox: "0 0 43.524 43.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.372,
    cy: 1.001,
    r: 1.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#ff543f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#fc5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#e64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#d53e91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#cc39a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#c837ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.161,
    cy: -0.012,
    r: 0.828,
    gradientTransform: "translate(0 -0.004) scale(1 0.666)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4168c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168c9",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.99 -5.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.857,49.491l-24.167.023a9.7,9.7,0,0,1-9.677-9.657L5.99,15.69a9.7,9.7,0,0,1,9.657-9.677L39.815,5.99a9.7,9.7,0,0,1,9.677,9.657l.023,24.167A9.694,9.694,0,0,1,39.857,49.491Z",
    transform: "translate(0)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.857,49.491l-24.167.023a9.7,9.7,0,0,1-9.677-9.657L5.99,15.69a9.7,9.7,0,0,1,9.657-9.677L39.815,5.99a9.7,9.7,0,0,1,9.677,9.657l.023,24.167A9.694,9.694,0,0,1,39.857,49.491Z",
    transform: "translate(0)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.459,33.917a8.459,8.459,0,1,1,8.459-8.459A8.469,8.469,0,0,1,25.459,33.917Zm0-14.5A6.042,6.042,0,1,0,31.5,25.459,6.049,6.049,0,0,0,25.459,19.417Z",
    transform: "translate(2.294 2.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(34.743 16.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.959,42.418h-14.5A8.469,8.469,0,0,1,11,33.959v-14.5A8.469,8.469,0,0,1,19.459,11h14.5a8.469,8.469,0,0,1,8.459,8.459v14.5A8.469,8.469,0,0,1,33.959,42.418Zm-14.5-29a6.049,6.049,0,0,0-6.042,6.042v14.5A6.049,6.049,0,0,0,19.459,40h14.5A6.049,6.049,0,0,0,40,33.959v-14.5a6.049,6.049,0,0,0-6.042-6.042Z",
    transform: "translate(1.044 1.044)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6d50e42c837f91f8d669f38362790ff7.svg";
export { ForwardRef as ReactComponent };